// Etapas de obra com percentuais para cálculo de orçamento por CUB
// Fonte: NBR 12721 / SINDUSCON - distribuição típica de custos

export const ETAPAS_OBRA = [
  { id: 1, nome: 'Projetos e Aprovações', percentual: 3 },
  { id: 2, nome: 'Instalações do Canteiro', percentual: 2 },
  { id: 3, nome: 'Fundações', percentual: 5 },
  { id: 4, nome: 'Estrutura', percentual: 15 },
  { id: 5, nome: 'Alvenaria', percentual: 7 },
  { id: 6, nome: 'Cobertura / Telhado', percentual: 4 },
  { id: 7, nome: 'Instalações Hidráulicas', percentual: 7 },
  { id: 8, nome: 'Instalações Elétricas', percentual: 6 },
  { id: 9, nome: 'Impermeabilização', percentual: 2 },
  { id: 10, nome: 'Reboco e Revestimento', percentual: 8 },
  { id: 11, nome: 'Contrapiso e Piso', percentual: 8 },
  { id: 12, nome: 'Forro', percentual: 3 },
  { id: 13, nome: 'Esquadrias (Portas e Janelas)', percentual: 7 },
  { id: 14, nome: 'Pintura', percentual: 5 },
  { id: 15, nome: 'Louças e Metais', percentual: 4 },
  { id: 16, nome: 'Limpeza e Acabamento Final', percentual: 2 },
  { id: 17, nome: 'Diversos e Imprevistos', percentual: 12 },
];

// Itens especiais opcionais com valor estimado fixo
// Valores unificados com CUB_EXTRAS (cubData.js) — sempre usar o maior valor
export const ITENS_ESPECIAIS = [
  { id: 'churrasqueira', nome: 'Churrasqueira', valor: 5000 },
  { id: 'piscina', nome: 'Piscina', valor: 65000 },
  { id: 'muro_portao', nome: 'Muro e Portão', valor: 35000 },
  { id: 'cisterna', nome: 'Cisterna / Caixa d\'água extra', valor: 4000 },
  { id: 'energia_solar', nome: 'Energia Solar (Fotovoltaica)', valor: 18000 },
  { id: 'paisagismo', nome: 'Paisagismo', valor: 25000 },
  { id: 'ar_condicionado', nome: 'Infraestrutura Ar-condicionado', valor: 6000 },
  { id: 'automacao', nome: 'Automação Residencial', valor: 12000 },
];

// Mapa tipo construção + padrão → código CUB
export const TIPO_PARA_CUB = {
  casa_terrea: {
    baixo: 'R1-B',
    normal: 'R1-N',
    alto: 'R1-A',
  },
  sobrado: {
    baixo: 'R1-B',
    normal: 'R1-N',
    alto: 'R1-A',
  },
  apartamento: {
    baixo: 'R8-N',
    normal: 'R8-N',
    alto: 'R8-A',
  },
  galpao: {
    baixo: 'GI',
    normal: 'GI',
    alto: 'GI',
  },
};

export const TIPOS_CONSTRUCAO = [
  { value: 'casa_terrea', label: 'Casa Térrea' },
  { value: 'sobrado', label: 'Sobrado' },
  { value: 'apartamento', label: 'Apartamento' },
  { value: 'galpao', label: 'Galpão Industrial' },
];

export const PADROES_CONSTRUCAO = [
  { value: 'baixo', label: 'Padrão Baixo' },
  { value: 'normal', label: 'Padrão Normal' },
  { value: 'alto', label: 'Padrão Alto' },
];
